(() => {
  const testId = 'home_meereswelt_v1';
  const variant = 'manta_airy_blue';
  const measurementId = 'G-SP7RV0ZSQ6';
  const rootSelector = `[data-home-variant="${testId}"]`;
  const pendingGa4Events = [];
  const developmentThemeRoles = new Set(['development', 'unpublished']);
  let analyticsAllowed = false;

  window.dataLayer = window.dataLayer || [];

  const initializeGoogleTag = () => {
    if (window.__lexiboSeaHomeGoogleTagInitialized) return;

    window.__lexiboSeaHomeGoogleTagInitialized = true;
    window.gtag =
      window.gtag ||
      function () {
        window.dataLayer.push(arguments);
      };

    window.gtag('consent', 'default', {
      analytics_storage: 'granted',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied'
    });
    window.gtag('js', new Date());
    window.gtag('config', measurementId, {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false
    });

    if (!document.querySelector('script[data-lexibo-homepage-ga4]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
      script.dataset.lexiboHomepageGa4 = '';
      document.head.appendChild(script);
    }
  };

  const sendToGa4 = (payload) => {
    if (!analyticsAllowed) return;

    initializeGoogleTag();

    const { event, ...parameters } = payload;
    const themeRole = window.Shopify?.theme?.role;

    window.gtag('event', event, {
      ...parameters,
      send_to: measurementId,
      ...(developmentThemeRoles.has(themeRole) ? { debug_mode: true } : {})
    });
  };

  const trackEvent = (payload) => {
    window.dataLayer.push({ ...payload });

    if (analyticsAllowed) {
      sendToGa4(payload);
    } else {
      pendingGa4Events.push({ ...payload });
    }
  };

  const enableAnalytics = () => {
    if (analyticsAllowed) return;

    analyticsAllowed = true;
    initializeGoogleTag();
    pendingGa4Events.splice(0).forEach(sendToGa4);
  };

  const updateAnalyticsConsent = () => {
    const customerPrivacy = window.Shopify?.customerPrivacy;
    if (!customerPrivacy) return;

    if (customerPrivacy.analyticsProcessingAllowed()) {
      enableAnalytics();
      return;
    }

    analyticsAllowed = false;
    if (window.__lexiboSeaHomeGoogleTagInitialized) {
      window.gtag('consent', 'update', { analytics_storage: 'denied' });
    }
  };

  const initializePrivacy = () => {
    if (window.Shopify?.customerPrivacy) {
      updateAnalyticsConsent();
      return;
    }

    if (!window.Shopify?.loadFeatures) return;

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) updateAnalyticsConsent();
    });
  };

  const pushView = () => {
    if (window.__lexiboSeaHomeViewSent || !document.querySelector(rootSelector)) return;

    window.__lexiboSeaHomeViewSent = true;
    trackEvent({
      event: 'homepage_test_view',
      test_id: testId,
      variant,
      placement: 'homepage',
      product_role: 'hero',
      product_handle: 'manta-rays-t-shirt-herren',
      destination_url: window.location.href,
      link_text: ''
    });
  };

  if (!window.__lexiboSeaHomeClickBound) {
    window.__lexiboSeaHomeClickBound = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest(`a[data-home-test="${testId}"][data-home-path]`);
      if (!link) return;

      trackEvent({
        event: 'homepage_path_click',
        test_id: testId,
        variant: link.dataset.variant || variant,
        placement: link.dataset.placement || '',
        product_role: link.dataset.productRole || '',
        product_handle: link.dataset.productHandle || '',
        destination_url: link.href,
        link_text: link.dataset.linkText || link.textContent.trim()
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pushView, { once: true });
  } else {
    pushView();
  }

  if (!window.__lexiboSeaHomeSectionBound) {
    window.__lexiboSeaHomeSectionBound = true;
    document.addEventListener('shopify:section:load', pushView);
  }

  if (!window.__lexiboSeaHomeConsentBound) {
    window.__lexiboSeaHomeConsentBound = true;
    document.addEventListener('visitorConsentCollected', updateAnalyticsConsent);
  }

  initializePrivacy();
})();
